import { useEffect, useState } from "react";
import axios from "../api/client";
import { useTranslation } from "react-i18next";

const PROVIDERS = ["neste_corp", "st1_for_corporate", "abc_corp"];

export default function AdminDataQuality() {
  const { t } = useTranslation();
  const [issues, setIssues] = useState([]);
  const [status, setStatus] = useState("active");
  const [provider, setProvider] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    async function load() {
      try {
        setError("");
        const query = new URLSearchParams({ status, ...(provider ? { provider } : {}) });
        const { data } = await axios.get(`/api/admin/provider-data-quality?${query}`);
        setIssues(data.issues || []);
      } catch {
        setError(t("admin.dataQuality.error"));
      }
    }
    void load();
  }, [provider, status, t]);

  return <div className="max-w-5xl mx-auto space-y-4">
    <div className="bg-white border rounded-xl shadow p-4 flex justify-between gap-3 flex-wrap">
      <div><h1 className="text-2xl font-semibold">{t("admin.dataQuality.title")}</h1><p className="text-gray-600">{t("admin.dataQuality.description")}</p></div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 w-full sm:w-auto [&>div>label]:mb-1 [&>div>label]:text-xs [&>div>label]:block [&>div>select]:px-2 [&>div>select]:py-1.5 [&>div>select]:text-sm">
        <div><label>{t("admin.dataQuality.status")}</label><select value={status} onChange={(e) => setStatus(e.target.value)} aria-label={t("admin.dataQuality.status")} className="w-full border rounded-lg px-3 py-2"><option value="active">{t("admin.dataQuality.active")}</option><option value="resolved">{t("admin.dataQuality.resolved")}</option></select></div>
        <div><label>{t("admin.dataQuality.provider")}</label><select value={provider} onChange={(e) => setProvider(e.target.value)} aria-label={t("admin.dataQuality.provider")} className="w-full border rounded-lg px-3 py-2"><option value="">{t("admin.dataQuality.allProviders")}</option>{PROVIDERS.map((item) => <option key={item} value={item}>{item}</option>)}</select></div>
      </div>
    </div>
    {error && <p className="text-red-600">{error}</p>}
    <div className="bg-white border rounded-xl shadow overflow-x-auto"><table className="min-w-full text-sm"><thead><tr><th>{t("admin.dataQuality.provider")}</th><th>{t("admin.dataQuality.product")}</th><th>{t("admin.dataQuality.type")}</th><th>{t("admin.dataQuality.firstSeen")}</th><th>{t("admin.dataQuality.lastSeen")}</th><th>{t("admin.dataQuality.count")}</th></tr></thead><tbody>{issues.map((x) => <tr key={`${x.provider}-${x.issue_type}-${x.product_name}`}><td>{x.provider}</td><td>{x.product_name}{x.product_code ? ` (${x.product_code})` : ""}</td><td>{t(`admin.dataQuality.issueTypes.${x.issue_type}`)}</td><td>{new Date(x.first_seen_at).toLocaleString()}</td><td>{new Date(x.last_seen_at).toLocaleString()}</td><td>{x.occurrence_count}</td></tr>)}{!issues.length && <tr><td colSpan="6" className="py-8 text-center font-medium text-green-700">{t("admin.dataQuality.none")}</td></tr>}</tbody></table></div>
  </div>;
}
